import { alertController } from '@ionic/vue';
import { defineStore } from "pinia";
import { GenericCallbackFunction } from "@movinglayers/types";
import { i18n } from "@/lang/i18n.ts";

export const useAlertsStore = defineStore("alerts", () => {

    // using global i18n instead of useI18n because it also works if called from vue-router hook
    const { t } = i18n.global;

    const getMissingPermissionAlert = (confirmCallback?: GenericCallbackFunction, cancelCallback?: GenericCallbackFunction) =>
        alertController.create({
            header: t("permissions.locationTitle"),
            message: t("permissions.locationMessage"),
            buttons: [
                {
                    text: t("helpers.cancel"),
                    role: 'cancel',
                    handler: confirmCallback,
                },
                {
                    text: t("permissions.openSettings"),
                    role: 'confirm',
                    handler: cancelCallback,
                },
            ],
        });

    const getErrorWhileAuthenticatingAlert = (confirmCallback?: GenericCallbackFunction) => alertController.create({
        header: t("alert.errorWhileAuthenticatingTitle"),
        message: t("alert.errorWhileAuthenticatingBody"),
        buttons: [
            {
                text: t("alert.buttonToLogin"),
                role: 'confirm',
                handler: confirmCallback,
            },
        ],
    });

    return {
        getMissingPermissionAlert,
        getErrorWhileAuthenticatingAlert,
    };
});